export default __webpack_public_path__ + "static/media/logo.3733f1d3.png";